import React,
{
    forwardRef,
    useImperativeHandle,
    useRef,
    useState
} from 'react';
import Select, { components } from 'react-select';
import style from './reactSelect.module.scss';
import ExpandMore from '@assets/images/Fireboard/ExpandMore';

const defaultCustomStyles = (isMenuOpen) => ({
    control: (provided, state) => ({
        ...provided,
        height: window.innerWidth == 1920 ? '4rem' : '3rem',
        border: state.isFocused ? '1px solid #96AEFF' : 'none',
        background: 'var(--react-select-bg)',
        boxShadow: 'none',
        ':hover': {
            border: '1px solid #96AEFF'
        },
        borderRadius: '8px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        fontWeight: '500',
        color: '#FFF',
        padding: '8px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#FFF',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#FFF',
        ':hover': {
            color: '#FFF',
        },
        transition: 'transform 0.2s',
        transform: isMenuOpen ? 'rotate(180deg)' : null
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'var(--react-select-text)',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: 'white',
    }),
    menuList: (base) => ({
        ...base,
        padding: 0,
        borderRadius: '7px',
    }),
    menu: (base) => ({
        ...base,
        borderRadius: '8px',
        marginTop: '6px',
        backgroundColor: 'var(--react-select-menu-bg)',
        border: '1px solid var(--hamburger-border)',
        boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.16)',
    }),
    option: (provided, state) => ({
        ...provided,
        cursor: 'pointer',
        height: window.innerWidth == 1920 ? '4rem' : '3rem',
        display: 'flex',
        alignItems: "center",
        fontWeight: state.isSelected ? '500' : '400',
        textAlign: 'left',
        color: 'var(--react-select-text)',
        backgroundColor: state.isSelected ? 'var(--react-select-selected-option)' : 'transparent',
        ':hover': {
            backgroundColor: state.isSelected ? 'var(--react-select-selected-option)' : 'var(--table-header-bg)',
        },
        ':active': {
            backgroundColor: 'var(--react-select-selected-option)',
        },
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    })

});


const customComponents = {
    DropdownIndicator: (props) => (
        <components.DropdownIndicator {...props}>
            <ExpandMore />
        </components.DropdownIndicator>
    )
};

const ReactSelector = forwardRef((props, ref) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const selectRef = useRef(null);
    useImperativeHandle(
        ref,
        () => ({
            getValue: () => {
                return selectRef.current.state.value;
            }
        }),
        []
    );
    const {
        name,
        id,
        options,
        placeholder,
        isMulti,
        isDisabled,
        isClearable,
        maxMenuHeight,
        // isSearchable,
        className,
        onChange,
        customLabel,
        onSelect = () => { },
        customId,
        defaultValue,
        getIcon,
        noLabel
    } = props;

    return (
        <div className={style.fontSize}>
            {name && !noLabel && (
                <label className={style.customLabel}>
                    {customLabel}
                </label>
            )}
            <Select
                name={name}
                isDisabled={isDisabled}
                isSearchable={false}
                placeholder={placeholder}
                className={className}
                isMulti={isMulti}
                maxMenuHeight={maxMenuHeight}
                isClearable={isClearable}
                options={options}
                id={id}
                ref={selectRef}
                blurInputOnSelect
                getOptionLabel={(option) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {getIcon ? getIcon(option) : null} {option.name}
                    </div>
                )}
                getOptionValue={(option) => { return customId ? option[customId] : option.id; }}
                onChange={(data) => { if (onChange) onChange(data); }}
                value={options.filter((item) => item.id === defaultValue)[0]}
                styles={defaultCustomStyles(isMenuOpen)}
                onFocus={() => onSelect()}
                setImenuIsOpen={isMenuOpen}
                onMenuOpen={() => setIsMenuOpen(true)}
                onMenuClose={() => setIsMenuOpen(false)}
                components={customComponents}
                theme={(theme) => ({
                    ...theme,
                    borderRadius: '3px',
                    borderWidth: '2px',
                    borderColor: 'rgba(173, 0, 40, 0.25)',
                    boxShadow: '0 0 0 0.2rem rgba(173, 0, 40, 0.25)',
                    colors: {
                        ...theme.colors,
                        primary: 'rgb(75,75,75)',
                    },
                })}
            />
        </div>
    );
});
export default ReactSelector;
